var environment;
const environments = {
    dev: {
        TITLE: "Backend - Entwicklungsumgebung",
        API_HOST: "http://localhost:5005",
        DELIVERY_HOST: "https://go.dev.qrsticker.de",
        COGNITO_REGION: "eu-central-1",
        COGNITO_USER_POOL: "eu-central-1_AqpggmlMq",
        COGNITO_CLIENT_ID: "109j4inud2ihel7g2o3hudtfto",
        CDN_HOST: "https://cdn.dev.qrsticker.de"
    },
    stage: {
        TITLE: "Backend - Entwicklungsumgebung",
        API_HOST: "https://api.dev.qrsticker.de",
        DELIVERY_HOST: "https://go.dev.qrsticker.de",
        COGNITO_REGION: "eu-central-1",
        COGNITO_USER_POOL: "eu-central-1_AqpggmlMq",
        COGNITO_CLIENT_ID: "109j4inud2ihel7g2o3hudtfto",
        CDN_HOST: "https://cdn.dev.qrsticker.de"
    },
    prod: {
        TITLE: "Backend",
        API_HOST: "https://api.qrsticker.de",
        DELIVERY_HOST: "https://go.qrsticker.de",
        COGNITO_REGION: "eu-central-1",
        COGNITO_USER_POOL: "eu-central-1_AqpggmlMq",
        COGNITO_CLIENT_ID: "109j4inud2ihel7g2o3hudtfto",
        CDN_HOST: "https://cdn.qrsticker.de"
    }
}

switch (window.location.hostname)
{
    case "localhost":
        environment = environments.dev;
        break;
    case "admin.dev.qrsticker.de":
        environment = environments.stage;
        break;
    case "admin.qrsticker.de":
        environment = environments.prod;
        break;
    default:
        break;
}

export default environment;
